const gradients = [
  "linear(135deg, #667eea 0%, #764ba2 100%)",
  "linear(135deg, #f093fb 0%, #f5576c 100%)",
  "linear(135deg, #4facfe 0%, #00f2fe 100%)",
  "linear(135deg, #43e97b 0%, #38f9d7 100%)",
  "linear(135deg, #fa709a 0%, #fee140 100%)",
  "linear(135deg, #a8edea 0%, #fed6e3 100%)",
  "linear(135deg, #ff9a9e 0%, #fecfef 100%)",
  "linear(135deg, #ffecd2 0%, #fcb69f 100%)",
  "linear(135deg, #a18cd1 0%, #fbc2eb 100%)",
  "linear(135deg, #fad0c4 0%, #ffd1ff 100%)"
];

/**
 * Generates a consistent random gradient based on a url_key
 * Falls back to name if url_key is not provided for backwards compatibility
 */
export const getRandomGradient = (urlKey: string, fallbackName?: string): string => {
  const key = urlKey || fallbackName || 'default';
  const hash = key.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return gradients[hash % gradients.length];
};

/**
 * Gets initials from a list name (first letter of each word)
 */
export const getListInitials = (name: string): string => {
  if (!name) return '';
  const words = name.trim().split(/\s+/);
  return words
    .map(word => word.charAt(0).toUpperCase())
    .join('');
};